function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, CallToAction, Container, Heading, PlatformIcon } from '../../atoms';
import { DeDuveLogo, LightArrowRight } from '../../visuals';
import ReactConfigContext from '../../ReactConfigContext';
export default function Footer(param) {
    var labels = param.labels, action = param.action, content = param.content, emails = param.emails, navigationItems = param.navigationItems, additionalItems = param.additionalItems, contentItems = param.contentItems, socialItems = param.socialItems, legalItems = param.legalItems, secondaryAction = param.secondaryAction, className = param.className;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    var linkCx = twMerge('underline font-heading font-semibold text-navigation-base text-blue-500 transition-all hover:text-blue-300');
    return /*#__PURE__*/ React.createElement(Container, {
        name: Footer.name,
        background: "subtle",
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('grid items-center', 'grid-cols-1 grid-flow-row auto-rows-max', 'grid-areas-[logo,action,content,legal,stereo]', 'md:grid-cols-3', 'md:grid-areas-[logo_action_action,content_content_content,legal_legal_stereo]')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[logo] mb-8 md:mb-0"
    }, /*#__PURE__*/ React.createElement(DeDuveLogo, {
        className: "block mx-auto md:mx-0"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex grid-in-[action] flex-col bg-bg-base px-6 py-5 rounded-xl md:p-0 md:bg-transparent md:flex-row md:justify-end"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid items-center gap-3 md:grid-cols-[auto_auto_auto] md:gap-6"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        className: "text-red-700 leading-xtight"
    }, labels.action.title), /*#__PURE__*/ React.createElement(Body, {
        className: "block text-center md:text-left"
    }, labels.action.description), /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
        icon: /*#__PURE__*/ React.createElement(LightArrowRight, null)
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[content] pb-9 my-9 border-b border-fg-base/10 md:border-y md:py-9"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-9 md:gap-6 md:grid-cols-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-7"
    }, /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, content), !!(emails === null || emails === void 0 ? void 0 : emails.length) && /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-2 grid-cols-1 grid-flow-row auto-rows-max"
    }, emails.map(function(email) {
        return /*#__PURE__*/ React.createElement("a", {
            key: email,
            href: "mailto:".concat(email),
            className: linkCx
        }, email);
    })), !!(contentItems === null || contentItems === void 0 ? void 0 : contentItems.length) && /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-2 grid-cols-1 grid-flow-row auto-rows-max"
    }, contentItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: item.href
        }, item), {
            className: linkCx
        }), item.label);
    })), secondaryAction && /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement(CallToAction, _object_spread({
        buttonType: "icon-after",
        icon: /*#__PURE__*/ React.createElement(LightArrowRight, null)
    }, secondaryAction)))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-5"
    }, navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: "navitem-".concat(item.href)
        }, item), {
            className: twMerge('grid gap-4 grid-cols-[auto_1fr] items-center transition-all hover:text-red-700', item.className)
        }), /*#__PURE__*/ React.createElement(LightArrowRight, {
            className: "block w-[1.2rem] h-auto text-red-700"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "font-heading font-semibold text-navigation-lg"
        }, item.label));
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-between"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-4 grid-cols-1 grid-flow-row auto-cols-max mb-9 md:mb-0"
    }, additionalItems === null || additionalItems === void 0 ? void 0 : additionalItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: "additionalitem-".concat(item.href)
        }, item), {
            className: twMerge('font-heading font-semibold text-navigation-base transition-all hover:text-red-700', item.className)
        }), item.label);
    })), !!(socialItems === null || socialItems === void 0 ? void 0 : socialItems.length) && /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-start"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "font-heading text-body-small mr-4"
    }, labels.social), socialItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: "socialitem-".concat(item.platform, "-").concat(item.href)
        }, item), {
            className: twMerge('mx-4 transition-all hover:text-red-700', item.className)
        }), /*#__PURE__*/ React.createElement(PlatformIcon, {
            type: item.platform,
            size: "1.125rem",
            "aria-label": item.title
        }));
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "grid-in-[legal]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col md:flex-row"
    }, legalItems === null || legalItems === void 0 ? void 0 : legalItems.map(function(item) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({
            key: "legal-".concat(item.href)
        }, item), {
            className: twMerge('block font-heading font-semibold text-navigation-base mb-8 last-of-type:mb-0 md:mb-0 md:mr-8 transition-all hover:text-red-700', item.className)
        }));
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex grid-in-[stereo] font-heading text-navigation-base font-medium justify-center border-t border-fg-base/10 md:border-t-0 mt-8 pt-8 md:mt-0 md:pt-0 md:justify-end"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mr-2"
    }, "design by"), /*#__PURE__*/ React.createElement("a", {
        className: "font-semibold transition-all hover:text-red-700",
        target: "_blank",
        rel: "noreferrer",
        href: "https://stereo.agency"
    }, "stereo.agency"))));
}

//# sourceMappingURL=Footer.js.map